<mat-dialog-content>


  <div class="form-wrapper">
    <span class="sub-text">Who is this card for?</span>
    <form [formGroup]="pageForm" class="terra-error-style">
      <div class="form-row">
        <div class="form-control">
          <mat-label>* First Name</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="firstName" />
            <mat-error *ngIf="pageForm.get('firstName').hasError('required')">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="form-control">
          <mat-label>* Last Name</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="lastName" />
            <mat-error *ngIf="pageForm.get('lastName').hasError('required')">Required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="form-control">
          <mat-label>* Email</mat-label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="Name@mail.com" formControlName="email" />
            <mat-error *ngIf="pageForm.get('email').hasError('required')">Required</mat-error>
          </mat-form-field>
        </div>

        <!-- Date of birth -->
        <div class="terra-form-field-wrapper form-control birthDate">
          <terra-custom-utc-date-picker id="txtCardDob" formControlName="dateOfBirth" label="* Date of Birth"
              minDate="1900-01-01" [maxDate]="today"
              [requiredError]="pageForm.get('dateOfBirth').hasError('required')"
              [touched]="pageForm.get('dateOfBirth').touched"
              [minError]="pageForm.get('dateOfBirth').hasError('minDate')"
              [maxError]="pageForm.get('dateOfBirth').hasError('maxDate')"
              minErrorTxt="Please enter a valid date" maxErrorTxt="Please enter a valid date" startAt="1980-01-01"
              startView="multi-year"></terra-custom-utc-date-picker>
        </div>
      </div>

      <!-- Phone number -->
      <div class="form-row">
        <div class="form-control">
          <terra-phone class="terra-form-field-wrapper small-field" formControlName="phone">
            <label for="txtPhone" class="text-input-label">* Phone Number</label>
            <mat-error *ngIf="pageForm.get('phone').hasError('required')">Required</mat-error>
            <mat-error *ngIf="pageForm.get('phone').hasError('phone')">Invalid phone number</mat-error>
          </terra-phone>
          <!--  -->
        </div>
      </div>

      <!-- Address -->
      <section class="address-section">
        <span class="sub-text">Address</span>
        <terra-address-form [externalForm]="pageForm" [formSettings]="addressFormSettings"
          [locationDetailsResponse]="originalAddress$ | async" [optionalMark]="null" requireMark="*"
          class="form-fields address-form-new-card" partialFormName="address" street2Label="Second line of address"
          streetLabel="Street address">
        </terra-address-form>
      </section>


      <div class="form-row form-row-terms">
        <div class="form-control terms">
          <mat-checkbox formControlName="terms">I have Read and Agree to the
            <a *ngIf="(unitAccountThreadProvider$ | async); else choiceTerms"
              href="{{termType.getUrl(termType.ThreadBusinessDebitCardholderAgreement)}}" target="_blank">{{
              termType.toString(termType.ThreadBusinessDebitCardholderAgreement) }}</a>,
            <ng-template #choiceTerms>
              <a href="{{termType.getUrl(termType.CovercyBusinessDebitCardholderAgreement)}}" target="_blank">{{
                termType.toString(termType.CovercyBusinessDebitCardholderAgreement) }}</a>,
            </ng-template>
          </mat-checkbox>
        </div>
        <mat-error *ngIf="submit && pageForm.get('terms').hasError('required')">Please accept the above
          terms</mat-error>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="footer">
    <button type="button" (click)="submitForm()" [disabled]="pageForm.invalid" mat-flat-button color="primary">Issue
      Debit Card</button>
    <button type="button" mat-dialog-close mat-button color="default">Cancel</button>
  </div>
</mat-dialog-actions>